/**
 * Folder, under the app's base URL, where `vite.config.js` serves (dev) and
 * copies (build) `node_modules/pdfjs-dist/wasm/*`: the pdf.js 6 decoders for
 * JPEG 2000 and JBIG2 images (common in scanned PDFs) and colour profiles.
 */
export const PDFJS_WASM_DIR = 'pdfjs-wasm';

/**
 * The `wasmUrl` of pdf.js `getDocument`: the decoders' folder as an absolute
 * URL with the trailing slash pdf.js requires. Absolute on purpose: the
 * worker resolves it too (it imports the no-wasm fallbacks from there), and a
 * worker may run from a `blob:` URL.
 *
 * @param basePath the app's base path (`Globals.basePath`: `/` or `/admin/`).
 * @param pageUrl the current page URL (`window.location.href`).
 */
export function pdfjsWasmUrl(basePath: string, pageUrl: string): string {
  const base = basePath.endsWith('/') ? basePath : `${basePath}/`;
  return new URL(`${base}${PDFJS_WASM_DIR}/`, pageUrl).href;
}
